module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00069-fs8.142b755.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00069-fs8.png
// module id = 222
// module chunks = 0